<template>
	<div>
		<div style="background:#00A6E5;display: flex;justify-content: center;">
			<div style="height: 80px;width: 60%;display: flex;align-items: center;justify-content: space-between;">
				<div style="display: flex;align-items: center;">
					<span style="font-size: 28px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 40px;margin-left: 14px;">成为牛人</span>
				</div>
				<div @click="goBack" style="width: 80px;height: 36px;border-radius: 4px;border: 1px solid #FFFFFF;display: flex;align-items: center;justify-content: space-around;">
					<span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;
				">返回</span>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;">
			<div style="width: 60%;">
				<div style="display: flex;flex-direction:column;align-items:center;background: #FFFFFF;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);border-radius: 4px;margin-top: 30px;padding: 70px 30px 20px 30px;margin-bottom: 30px;">
					<div class="item_row">
						<span class="item_name">账号</span>
						<input class="input_val" type="text" placeholder="请输入账号" v-model="account">
					</div>
					<div class="item_row">
						<span class="item_name">账户类型</span>
						<select class="input_val"  v-model="type">
							<option value="">请选择账户类型</option>
						    <option value="标准账户">标准账户</option>
						    <option value="ECN账户">ECN账户</option>
						</select>
					</div>
					<div class="item_row">
						<span class="item_name">密码</span>
						<input class="input_val" type="password" placeholder="请输入账号密码"   v-model="passwd">
					</div>
					<div class="item_row">
						<span class="item_name">邮箱</span>
						<input class="input_val" type="email" placeholder="请输入邮箱" v-model="email">
					</div>
					<div class="item_row">
						<span class="item_name">昵称</span>
						<input class="input_val" type="text" placeholder="请输入昵称" v-model="nick_name">
					</div>
					<div class="item_row" style="align-items: flex-start;">
						<span class="item_name" style="margin-top:9px ;">牛人简介</span>
						<textarea class="input_val" style="height: 100px;" type="text" placeholder="请输入牛人简介"   v-model="desc"/>
					</div>
					<div class="item_row" >
						<span class="item_name" style="margin-top:9px ;">头像</span>
						<div style="flex:8;display: flex;align-items: center;justify-content: space-between;">
							<input class="input_val" accept="image/jpeg,image/png" ref="pic"  id='test'  @change="postPic(this)" type="file" />
							<img v-if="preView&&IMG_HOST" :src="IMG_HOST+preView" style="width: 100px;height: 100px;" alt="">
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 60px;">
						<button @click="postInfo" style="width: 240px;height: 50px;background: #00A6E5;border-radius: 4px;font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;border: none;">提交审核</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {HOST,IMG_HOST} from '../Api.js'
	export default {
		name: 'BecomeNiuren',
		props: {
			msg: String
		},
		data() {
			return {
				type:'',
				preView:'',
				IMG_HOST:IMG_HOST,
				account:'',
				passwd:'',
				email:'',
				avatar:'',
				nick_name:'',
				desc:'',
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			loadData() {

			},
			postInfo(){
				let postData =  {};
				postData.account = this.account;
				postData.passwd = this.passwd;
				postData.email = this.email;
				postData.avatar = this.preView;
				postData.nick_name = this.nick_name;
				postData.desc = this.desc;
				postData.type = this.type;
				console.log(postData);
				if(postData.account == ''){
					this.$layer.msg('请输入账号',{
						time:2
					});
					return;
				}
				if(postData.type == ''){
					this.$layer.msg('请选择账户类型',{
						time:2
					});
					return;
				}
				if(postData.passwd == ''){
					this.$layer.msg('请输入密码',{
						time:2
					});
					return;
				}
				if(postData.email == ''){
					this.$layer.msg('请输入邮箱',{
						time:2
					});
					return;
				}
				if(postData.avatar == ''){
					this.$layer.msg('请上传头像',{
						time:2
					});
					return;
				}
				if(postData.nick_name == ''){
					this.$layer.msg('请输入昵称',{
						time:2
					});
					return;
				}
				this.$layer.confirm('确定提交审核吗?', {
				  btn: ['确定','取消']     
				}, () => {      
					this.$layer.loading({content:'数据加载中'});
					fetch(HOST+'biggun/join',{
						method: 'POST',
						headers:{
							"Content-Type": "application/json;charset=utf8"
						},
						body:JSON.stringify(postData)
					}).then(response=>response.json()).then(res=>{
						this.$layer.closeAll();
						if(res.errcode === '0000'){
							this.$router.push({
								name:'SubmitSuccess',
								params:{
									type:1
								}
							});
						}else{
							this.$layer.msg(res.errmsg,{
								time:2
							});
						}
					})
				}, () => {   	
				  this.$layer.closeAll();
				})
				
			},
			postPic(e){
				let dom = document.getElementById('test');
				let files = dom.files;
				console.log(files[0])
				let formData = new FormData();
				formData.append('file', files[0]);
				console.log(formData)
				this.$layer.loading({content:'请求中'});
				fetch(HOST+'biggun/uploadHead',{
					method: 'POST',
					headers:{
						// "Content-Type": "application/x-www-form-urlencoded"
					},
					body:formData
				}).then(response=>response.json()).then(res=>{
					this.$layer.closeAll();
					this.preView = res.data.src;
				})
				// console.log(e,this.$refs.pic.get(0).files[0]);
				
			}
		}
	}
</script>

<style scoped>
	.top_block {
		height: 200px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
		border-radius: 4px;
		margin-top: 30px;
	}

	.img_left_block {
		display: flex;
		align-items: center;
	}

	.top_top {
		display: flex;
		justify-content: space-between;
		padding: 20px 30px 40px 30px;
	}

	.tips_item {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tips_str {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 18px;
	}

	.tips_val {
		font-size: 16px;
		font-family: Helvetica;
		color: #333333;
		line-height: 19px;
		margin-top: 6px;
	}

	.title_bar {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}
	.table_all{
		width: 100%;
		border: 1px solid #EDEFF1;
		border-collapse:collapse;  
		border-spacing:0px;
		margin-top: 20px;
	}
	.table_all th{
		background: #F1F5F7;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 48px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;

	}
	.table_all td{
		background: #FFFFFF;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 54px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
	}
	.item_row{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 60%;
		margin-top: 20px;
	}
	.item_name{
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
		flex:2;
	}
	.input_val{
		background: #FFFFFF;
		border-radius: 3px;
		border: 1px solid #CED4DA;
		flex: 8;
		padding: 9px 16px 9px 16px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
	}
</style>
